<lib-pill-button-group #climateZone [control]="control">
</lib-pill-button-group>
